<div class="container-fluid mt-4 position-relative">
  <!-- Bootstrap Spinner -->
  <div *ngIf="isLoading" class="spinner-container d-flex justify-content-center align-items-center">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div class="row align-items-start">
    <!-- Announcements & Study Materials Section -->
    <div class="col-12 col-md-6 d-flex flex-column">
      <h5 class="section-title d-flex align-items-center">
        <img src="assets/images/notifications_active.svg" alt="Logo" class="me-2 section-icon" />
        Announcements & Study Materials
        <span class="notification-badge ms-2">{{totalCount}}</span>
      </h5>
      <div class="flex-grow-1 d-flex flex-column recent p-2">
        <ng-container *ngIf="studentAnnouncementSent.length > 0 || studentAnnouncementReceived.length > 0; else noAnnouncement">
          <mat-card *ngFor="let studentAnnouncement of studentAnnouncementSent" class="announcement-post">
            <div class="d-flex align-items-center mb-2">
              <img src="assets/images/avatar.png" alt="profile" class="avatar me-2" />
              <div>
                <strong>{{ studentAnnouncement.teacher_name }}</strong>
                <div class="text-muted small">
                  {{ studentAnnouncement.created_at | istDate }}
                </div>
              </div>
            </div>
            <div class="mb-2">{{ studentAnnouncement.content }}</div>

            <div *ngIf="studentAnnouncement.materials?.length">
              <ng-container *ngFor="let material of studentAnnouncement.materials || []">
                <ng-container *ngIf="material.is_material_file">
                  <a *ngIf="material.original_file_s3_url; else fileReadyOnly"
                    [href]="material.original_file_s3_url" target="_blank"
                    rel="noopener noreferrer" download
                    class="pdf-bg mb-2 d-flex align-items-center justify-content-between p-2">
                    <div class="d-flex align-items-center w-75">
                      <img src="assets/images/link-file.svg" alt="attachment" class="attachment-logo" />
                      <span class="material-name">{{ material.material_name }}</span>
                    </div>
					<div class="w-25">
                    <button class="btn-download">
                      <i class="bi bi-download me-2"></i>Download
                    </button></div>
                  </a>

                  <ng-template #fileReadyOnly>
                    <span *ngIf="material.extracted_file_s3_url"
                      class="pdf-bg pdf-disabled mb-2 d-flex align-items-center gap-2 p-2">
                      <mat-icon>picture_as_pdf</mat-icon>
                      {{ material.material_name }}
                    </span>
                  </ng-template>
                </ng-container>
                <a *ngIf="material.original_website_url"
                  [href]="material.original_website_url" target="_blank" rel="noopener noreferrer"
                  class="pdf-bg d-flex align-items-center gap-2 p-2 mb-2">
                  <mat-icon>link</mat-icon>
                  {{ material.original_website_url }}
                </a>
                <div
                  *ngIf="!material?.is_material_file && material.extracted_file_s3_url">
                  <a [href]="material.extracted_file_s3_url" target="_blank"
                    rel="noopener noreferrer" class="pdf-bg mb-2 d-flex align-items-center gap-2 p-2">
                    <mat-icon>link</mat-icon>
                    <span>{{ material.material_name }}</span>
                  </a>
                </div>
              </ng-container>
            </div>
          </mat-card>

          <mat-card *ngFor="let studentAnnouncement of studentAnnouncementReceived" class="announcement-post">
            <div class="d-flex align-items-center mb-2">
              <img src="assets/images/avatar.png" alt="profile" class="avatar me-2" />
              <div>
                <strong>{{ studentAnnouncement.teacher_name }}</strong>
                <div class="text-muted small">
                  {{ studentAnnouncement.created_at | istDate }}
                </div>
              </div>
            </div>
            <div class="mb-2">{{ studentAnnouncement.content }}</div>

            <div *ngIf="studentAnnouncement.materials?.length">
              <ng-container *ngFor="let material of studentAnnouncement.materials || []">
                <ng-container *ngIf="material.is_material_file">
                  <a *ngIf="material.original_file_s3_url; else fileReadyOnly"
                    [href]="material.original_file_s3_url" target="_blank"
                    rel="noopener noreferrer" download
                    class="pdf-bg mb-2 d-flex align-items-center justify-content-between p-2">
                    <div class="d-flex align-items-center gap-2">
                      <img src="assets/images/link-file.svg" alt="attachment" class="attachment-logo" />
                      <span class="material-name">{{ material.material_name }}</span>
                    </div>
                    <button class="btn-download">
                      <i class="bi bi-download me-2"></i>Download
                    </button>
                  </a>

                  <ng-template #fileReadyOnly>
                    <span *ngIf="material.extracted_file_s3_url"
                      class="pdf-bg pdf-disabled mb-2 d-flex align-items-center gap-2 p-2">
                      <mat-icon>picture_as_pdf</mat-icon>
                      {{ material.material_name }}
                    </span>
                  </ng-template>
                </ng-container>
                <a *ngIf="material.original_website_url"
                  [href]="material.original_website_url" target="_blank" rel="noopener noreferrer"
                  class="pdf-bg d-flex align-items-center gap-2 p-2">
                  <mat-icon>link</mat-icon>
                  {{ material.original_website_url }}
                </a>
                <div
                  *ngIf="!material.is_material_file && material.extracted_file_s3_url">
                  <a [href]="material.extracted_file_s3_url" target="_blank"
                    rel="noopener noreferrer" class="pdf-bg mb-2 d-flex align-items-center gap-2 p-2">
                    <mat-icon>link</mat-icon>
                    <span>{{ material.material_name }}</span>
                  </a>
                </div>
              </ng-container>
            </div>
          </mat-card>
        </ng-container>
      </div>
    </div>

    <!-- No Announcement Template -->
    <ng-template #noAnnouncement>
      <div class="flex-grow-1 d-flex flex-column recent">
        <mat-card class="p-3 text-center h-100 py-5">
          <div class="d-flex justify-content-center mt-3">
            <img src="assets/images/noAnnouncement.png" alt="No Announcement" class="no-announcement-img" />
          </div>
          <span class="mt-3 mb-5">No announcement yet</span>
        </mat-card>
      </div>
    </ng-template>

    <!-- Recent Updates Section -->
    <div class="col-12 col-md-6 mb-3 d-flex flex-column">
      <h5 class="section-title d-flex align-items-center">
        <img src="assets/images/notifications_unread.svg" alt="Recent Updates Icon" class="section-icon me-2" />
        Recent Updates 
        <span class="notification-badge ms-2">{{totalRecentUpdateCount}}</span>
      </h5>

      <ng-container *ngIf="studentRecentUpdate.length === 0 && !isLoadingRecentUpdates">
        <div class="flex-grow-1 d-flex flex-column recent p-2">
          <mat-card class="p-3 text-center h-100 py-5">
            <div class="d-flex justify-content-center mt-3">
              <img src="assets/images/noReceived.png" alt="No Recent Update" class="no-updates-img" />
            </div>
            <span class="mt-3 mb-5">No Recent Update</span>
          </mat-card>
        </div>
      </ng-container>

      <ng-container *ngIf="studentRecentUpdate.length > 0 && !isLoadingRecentUpdates">
        <div class="col-md-12 p-2 recent">
          <div class="study-grid flex-grow-1 d-flex flex-column">
            <div class="study-card" *ngFor="let studentUpdate of studentRecentUpdate">
              <div class="material-header justify-content-between">
                <div class="text-start">
                  <img *ngIf="studentUpdate.type === notificationTypeEnum.Quiz"
                    src="assets/images/Frame1.png" alt="file icon" class="me-3"/>
                  <img *ngIf="studentUpdate.type === notificationTypeEnum.Course"
                    src="assets/images/Frame2.png" alt="file icon" class="me-3"/>
                  <span class="material-title truncate-url">{{studentUpdate.title}}</span>
                </div>
                <div class="text-end">
                  <div class="text-end">
                    <span class="badge-quiz" *ngIf="studentUpdate.type === notificationTypeEnum.Quiz">quiz</span>
                    <span class="badge-quiz badge-course" *ngIf="studentUpdate.type === notificationTypeEnum.Course">course</span>
                  </div>
                </div>
              </div>
              <div class="material-meta justify-content-between">
                <div class="text-start ms-2">
                  <img src="assets/images/clock_analog.svg" alt="clock-icon">  
                  <span class="ms-2">{{studentUpdate.created_at | istDate}}</span>
                </div>
                <div class="text-end m-0">
                  <div type="button" class="btn-add bg-course" *ngIf="studentUpdate.type === notificationTypeEnum.Course"
                    (click)="putStudentMarkedAsVisitCourse(studentUpdate)">view course</div>
                  <div type="button" class="btn-add bg-quiz" *ngIf="studentUpdate.type === notificationTypeEnum.Quiz"
                    (click)="putStudentMarkedAsVisitQuiz(studentUpdate)">view quiz</div>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>